import { createContext, useContext } from 'react'
import initializeStore from '@/stores/stores';

export const StoreContext = createContext();

export function useStore() {
  const context = useContext(StoreContext)
  if (context === undefined) {
    throw new Error('useStore must be used within StoreProvider')
  }

  return context
}


export function StoreProvider({ children, store: providedStore, initialState: initialData = null }) {
  // Use provided store if available, otherwise create new one
  const store = providedStore || initializeStore(initialData)
  
  if (providedStore) {
    console.log('🏪 StoreProvider using PROVIDED store instance');
  } else {
    console.log('🏪 StoreProvider creating NEW store instance');
  }

  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
}